/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Scope_Detail5Inputs */

const en_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map exactly what's done by hand, how often, and the risk of failure.`)
};

const ar_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدد بدقة ما يُنجز يدويًا وكم مرة وخطر الفشل.`)
};

const bn_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কী কী হাতে করা হয়, কত ঘন ঘন, এবং ফেইলিওরের ঝুঁকি, ম্যাপ করুন।`)
};

const de_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen Sie genau dar, was wie oft von Hand erledigt wird und wie hoch das Risiko eines Fehlers ist.`)
};

const es_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapee exactamente lo que se hace a mano, con qué frecuencia y el riesgo de falla.`)
};

const fr_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartographiez exactement ce qui est fait à la main, à quelle fréquence et le risque d'échec.`)
};

const pt_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapeie exatamente o que é feito manualmente, com que frequência e o risco de falha.`)
};

const zh_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`梳理清楚哪些靠手工、多频繁，以及失败风险。`)
};

const tr_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam olarak neyin elle, ne sıklıkla yapıldığını ve hata riskini çıkarın.`)
};

const ru_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Точно составьте карту того, что делается вручную, как часто и риск неудачи.`)
};

const pl_svc_automation_scope_detail5 = /** @type {(inputs: Svc_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpisz dokładnie, co robione ręcznie, jak często i ryzyko porażki.`)
};

/**
* | output |
* | --- |
* | "Map exactly what's done by hand, how often, and the risk of failure." |
*
* @param {Svc_Automation_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_scope_detail5 = /** @type {((inputs?: Svc_Automation_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_automation_scope_detail5(inputs)
	if (locale === "de") return de_svc_automation_scope_detail5(inputs)
	if (locale === "es") return es_svc_automation_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_automation_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_automation_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_automation_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_automation_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_automation_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_automation_scope_detail5(inputs)
	return en_svc_automation_scope_detail5(inputs)
});
export { svc_automation_scope_detail5 as "svc_automation_SCOPE_detail" }